{
  "version": 1,
  "asset_id": "37c5d60d-7162-4705-bae8-37bccd99df2f",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/37c5d60d-7162-4705-bae8-37bccd99df2f/gallery-2.jpeg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/37c5d60d-7162-4705-bae8-37bccd99df2f/gallery-2.jpeg",
  "original_filename": "gallery-2.jpeg",
  "size": 770410,
  "content_type": "image/jpeg",
  "created_at": "2026-07-01T04:21:36Z"
}
